import { createAsyncThunk } from '@reduxjs/toolkit'

import { registration, signIn, validate } from '../../services/auth'
import { getProfileInfo } from '../../services/userProfile'
import { handleError } from '../../helpers/handleError'

export const login = createAsyncThunk(
  `auth/login`,
  async ({ email, password }: Omit<UserCredentials, 'username'>) => {
    try {
      return await signIn({
        email,
        password,
      })
    } catch (error) {
      handleError(error)
    }
  },
)

export const signUp = createAsyncThunk(
  `auth/registration`,
  async ({ username, password, email }: UserCredentials) => {
    try {
      const res = registration({
        username,
        password,
        email,
      })
      return res
    } catch (error) {
      handleError(error)
    }
  },
)

export const validateCredentials = createAsyncThunk(
  'auth/validate',
  async ({ username, email }: { username: string; email: string }) => {
    try {
      const res = await validate({ username, email })
      return res
    } catch (err) {
      handleError(err)
    }
  },
)

export const getCurrentUser = createAsyncThunk(`user/current`, async () => {
  return await getProfileInfo()
})
